<template>
  <section class="dest">
    <div class="row">
      <!--left column: pickup-->
      <div class="col-lg col-md-24 mb-4">
        <div
          class="dest-content dest-pickup outlined rounded-lg p-4 t-bg-white"
          style="border-color: #6B7280;"
        >
          <div class="clearfix">
            <h2 class="h5 mb-4 float-left">Pickup location</h2>
            <div class="float-right" v-if="hasManyPickupLocations">
              <button
                type="button"
                class="btn-link"
                @click="showForm({ type: 'pickup' })"
                style="font-size: 14px;font-weight: bold; background: transparent;"
              >
                <i class="far fa-plus-circle"></i>
                Add new
              </button>
            </div>
          </div>
          <div
            v-if="!hasManyPickupLocations"
            style="display: flex; justify-content: center; align-items: center; min-height: 60%;"
          >
            <button
              type="button"
              class="btn btn-success btn-lg"
              @click="showForm({ type: 'pickup' })"
            >
              Setup a pickup location
            </button>
          </div>
          <div v-show="hasManyPickupLocations">
            <small v-show="errors.has('pickup_location')" class="text-danger">
              {{ errors.first("pickup_location") }}
            </small>

            <div class="is-invalid">
              <location-selector
                :loading="locations.pickupLoading"
                :locations="locations.pickup"
                :selected="pickup.location"
                type="pickup"
                @showForm="showForm($event)"
              >
              </location-selector>
            </div>

            <div class="form-row">
              <div class="form-group col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pickup Reference"
                  style="border-color: #4B5563;"
                  v-model="pickup.reference"
                />
              </div>
              <div class="form-group col-sm-14">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    style="border-bottom-right-radius:0.25rem !important; border-top-right-radius:0.25rem !important; border-color: #4B5563;"
                    placeholder="Special pickup instructions"
                    v-model="pickup.instructions"
                    @keydown.tab.prevent="handleFocus('receiverRef')"
                  />

                  <a-popover
                    class="info info-instructions"
                    width="400"
                    visible-arrow="true"
                    trigger="hover"
                    placement="bottom"
                  >
                    <template slot="content">
                      <div style="max-width:200px">
                        We will try and meet any special instructions, we may
                        need to get back to you with an adjusted price due to
                        any additional costs that are required to meet your
                        needs.
                      </div>
                    </template>
                    <i class="far fa-info-circle"></i>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--right column: delivery-->
      <div class="col-lg col-md-24 mb-4">
        <div
          class="dest-content dest-delivery rounded-lg outlined p-4 t-bg-white"
          style="border-color: #6B7280;"
        >
          <div class="clearfix">
            <h2 class="h5 mb-4 float-left">Delivery location</h2>
            <div class="float-right" v-if="hasManyDeliveryLocations">
              <button
                type="button"
                class="btn-link"
                @click="showForm({ type: 'delivery' })"
                style="font-size: 14px;font-weight: bold; background: transparent;"
              >
                <i class="far fa-plus-circle"></i> Add new
              </button>
            </div>
          </div>
          <div
            v-if="!hasManyDeliveryLocations"
            style="display: flex;justify-content: center; align-items: center; min-height: 60%;"
          >
            <button
              type="button"
              class="btn btn-success btn-lg"
              @click="showForm({ type: 'delivery' })"
            >
              Setup a delivery location
            </button>
          </div>
          <div v-show="hasManyDeliveryLocations">
            <small v-show="errors.has('delivery_location')" class="text-danger">
              {{ errors.first("delivery_location") }}
            </small>

            <location-selector
              :loading="locations.deliveryLoading"
              :locations="locations.delivery"
              :selected="delivery.location"
              type="delivery"
              @showForm="showForm($event)"
            >
            </location-selector>

            <div class="form-row">
              <div class="form-group col-sm-10">
                <input
                  ref="receiverRef"
                  type="text"
                  class="form-control"
                  placeholder="Delivery Reference"
                  style="border-color: #4B5563;"
                  v-model="delivery.reference"
                />
              </div>
              <div class="form-group col-sm-14">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    style=" border-bottom-right-radius:0.25rem !important; border-top-right-radius:0.25rem !important; border-color: #4B5563;"
                    placeholder="Special delivery instructions"
                    v-model="delivery.instructions"
                  />
                  <a-popover
                    class="info info-instructions"
                    width="400"
                    visible-arrow="true"
                    trigger="hover"
                    placement="bottom"
                  >
                    <template slot="content">
                      <div style="max-width:200px">
                        We will try and meet any special instructions, we may
                        need to get back to you with an adjusted price due to
                        any additional costs that are required to meet your
                        needs.
                      </div>
                    </template>
                    <i class="far fa-info-circle"></i>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <location-form-modal
      v-if="formShowing"
      :is-showing-modal="formShowing"
      :is-creating-location="isCreatingLocation"
      :location-to-edit="location"
      :location-type="locationType"
      @cancelled="formCancelled"
      @submitted="formSubmitted"
    />
  </section>
</template>

<script>
import LocationSelector from "./LocationSelector";
import LocationFormModal from "../../locations/components/LocationFormModal";

export default {
  name: "locations",
  components: {
    LocationSelector,
    LocationFormModal
  },
  props: ["locations", "pickup", "delivery"],
  inject: ["$validator"],

  data() {
    return {
      formShowing: false,
      location: null,
      selectorShowForm: "general",
      hasManyPickupLocations: true,
      hasManyDeliveryLocations: true,
      isCreatingLocation: true,
      locationType: null
    };
  },
  mounted() {
    let that = this;

    Event.$on("openForm", function(item) {
      that.showForm(item);
    });
  },
  methods: {
    showForm(payload) {
      this.selectorShowForm = payload.type;
      this.formShowing = true;

      if (payload) {
        if (payload.location) {
          this.location = payload.location;
          this.isCreatingLocation = false;
        } else {
          this.location = null;
          this.isCreatingLocation = true;
        }
        if (payload.type) {
          this.locationType = payload.type;
        }
      }
    },

    formSubmitted(payload) {
      this.formShowing = false;
      this.location = null;
      this.$emit("locationUpdated", payload);
    },

    formCancelled() {
      this.formShowing = false;
      this.location = null;
    },

    handleFocus(ref) {
      this.$refs[ref].focus();
    }
  },
  watch: {
    locations: {
      handler(val) {
        this.hasManyPickupLocations = !(
          val.pickup !== undefined && val.pickup.length === 0
        );
        this.hasManyDeliveryLocations = !(
          val.delivery !== undefined && val.delivery.length === 0
        );
      },
      deep: true
    }
  }
};
</script>
